var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":_vm.checked},on:{"change":_vm.clicked}}),_c('label',{class:{enhanced: _vm.checked},attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.val))])])}
var staticRenderFns = []

export { render, staticRenderFns }